module.exports = __webpack_public_path__ + "static/media/refresh.6d362a8d.png";